<template>
  <div>
    <div class="plan">
      <div class="t">
        信息更新
        <div v-if="status == -1" class="statusShow error">审核退回</div>
        <div v-if="status == 0" class="statusShow waiting">审核中</div>
        <div v-if="status == 1" class="statusShow end">审核通过</div>
      </div>
      <div class="return" @click="$router.back(-1)">
        返回上一级 <img src="@/assets/img/return.png" alt="" />
      </div>
    </div>
    <div class="statusBox">
      <img v-if="status == -1" src="@/assets/img/error.png" alt="" />
      <img v-if="status == 1" src="@/assets/img/success.png" alt="" />
      <img v-if="status == 0" src="@/assets/img/wait.png" alt="" />
      <div class="statusCont">
        <div class="item">
          <span class="t">审核状态：</span>
          <span class="c" v-if="status == -1">审核退回</span>
          <span class="c" v-if="status == 1">审核通过</span>
          <span class="c" v-if="status == 0">审核中</span>
        </div>
        <div class="item" v-if="status == -1 || status == 1">
          <span class="t">审核时间：</span>
          <span class="c">{{ time }}</span>
        </div>

        <div class="item" v-if="status == -1 || status == 0">
          <span class="t">审核反馈：</span>
          <span v-if="status == -1" class="c">{{
              remarks ? remarks : "无"
            }}</span>
          <span v-if="status == 0" class="c"
          >您提交的信息正在审核中，请耐心等待</span
          >
        </div>
      </div>
    </div>
    <div class="headBox">
      <div class="title">更新前</div>
      <div class="title">更新后</div>
    </div>
    <!--      <div class="contEach" v-if="Object.keys(this.upOld).length > 0">-->

    <div class="bg">
      <!--      基本信息-->
      <div
        class="contBox"
        style="margin-bottom: 48px"
        v-if="
          upNew.name ||
          upNew.province ||
          upNew.city ||
          upNew.county ||
          upNew.address ||
          upNew.com_create_time ||
          upNew.eco_type ||
          upNew.capital ||
          upNew.y_province ||
          upNew.y_city ||
          upNew.y_county ||
          upNew.y_address ||
          upNew.y_phone
        "
      >
        <div class="contT">1. 基本信息</div>
        <div class="contRightCont">
          <div class="cont" v-if="upNew && upNew.name">
            <!--          <div class="cont" v-if="oldDetail.name != newDetail.name">-->
            <div class="each">
              <div class="eachT">企业名称</div>
              <div class="eachD">
                {{ oldDetail.name ? oldDetail.name : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">企业名称</div>
              <div class="eachD">
                <!--                不一样时字体标红-->
                <!--                :class="this.upNew && this.upNew.name ? 'red' : ''"-->
                {{ newDetail.name ? newDetail.name : "--" }}
              </div>
            </div>
          </div>
          <div
            class="cont"
            v-if="upNew && (upNew.province || upNew.city || upNew.county)"
          >
            <div class="each">
              <div class="eachT">企业地址-省/市/区县</div>
              <div class="eachD">
                {{ oldDetail.province }}{{ oldDetail.city
                }}{{ oldDetail.county }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">企业地址-省/市/区县</div>
              <div class="eachD">
                {{ newDetail.province }}{{ newDetail.city
                }}{{ newDetail.county }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.address">
            <div class="each">
              <div class="eachT">企业地址-详细地址</div>
              <div class="eachD">
                {{ oldDetail.address ? oldDetail.address : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">企业地址-详细地址</div>
              <div class="eachD">
                {{ newDetail.address ? newDetail.address : "--" }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.com_create_time">
            <div class="each">
              <div class="eachT">成立时间</div>
              <div class="eachD">
                {{
                  oldDetail.com_create_time ? oldDetail.com_create_time : "--"
                }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">成立时间</div>
              <div class="eachD">
                {{
                  newDetail.com_create_time ? newDetail.com_create_time : "--"
                }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.eco_type">
            <div class="each">
              <div class="eachT">经济类型</div>
              <div class="eachD">
                {{ oldDetail.eco_type ? oldDetail.eco_type : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">经济类型</div>
              <div class="eachD">
                {{ newDetail.eco_type ? newDetail.eco_type : "--" }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.capital">
            <div class="each">
              <div class="eachT">注册资金（万元）</div>
              <div class="eachD">
                {{ oldDetail.capital ? oldDetail.capital : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">注册资金（万元）</div>
              <div class="eachD">
                {{ newDetail.capital ? newDetail.capital : "--" }}
              </div>
            </div>
          </div>
          <div
            v-show="comType == 2 || comType == 4"
            v-if="upNew && (upNew.y_province || upNew.y_city || upNew.y_county)"
            class="cont"
          >
            <div class="each">
              <div class="eachT">在滇办公地址-省/市/区县</div>
              <div class="eachD">
                {{ oldDetail.y_province }}{{ oldDetail.y_city
                }}{{ oldDetail.y_county }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">在滇办公地址-省/市/区县</div>
              <div class="eachD">
                {{ newDetail.y_province }}{{ newDetail.y_city
                }}{{ newDetail.y_county }}
              </div>
            </div>
          </div>
          <div
            v-show="comType == 2 || comType == 4"
            v-if="upNew && upNew.y_address"
            class="cont"
          >
            <div class="each">
              <div class="eachT">在滇办公地址-详细地址</div>
              <div class="eachD">
                {{ oldDetail.y_address ? oldDetail.y_address : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">在滇办公地址-详细地址</div>
              <div class="eachD">
                {{ newDetail.y_address ? newDetail.y_address : "--" }}
              </div>
            </div>
          </div>
          <div
            v-show="comType == 2 || comType == 4"
            v-if="upNew && upNew.y_phone"
            class="cont"
          >
            <div class="each">
              <div class="eachT">在滇办公电话</div>
              <div class="eachD">
                {{ oldDetail.y_phone ? oldDetail.y_phone : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">在滇办公电话</div>
              <div class="eachD">
                {{ newDetail.y_phone ? newDetail.y_phone : "--" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      负责人信息-->
      <div
        class="contBox"
        v-if="
          upNew.legal_name ||
          upNew.legal_tel ||
          upNew.legal_title ||
          upNew.technical_name ||
          upNew.technical_tel ||
          upNew.technical_title ||
          upNew.technical_code ||
          upNew.contact_name ||
          upNew.contact_tel ||
          upNew.contact_email
        "
        style="margin-bottom: 48px"
      >
        <div
          class="contT"
          v-if="
            upNew.name ||
            upNew.province ||
            upNew.city ||
            upNew.county ||
            upNew.address ||
            upNew.com_create_time ||
            upNew.eco_type ||
            upNew.capital ||
            upNew.y_province ||
            upNew.y_city ||
            upNew.y_county ||
            upNew.y_address ||
            upNew.y_phone
          "
        >
          2. 负责人信息
        </div>
        <div v-else class="contT">1. 负责人信息</div>
        <div class="contRightCont">
          <div class="cont" v-if="upNew && upNew.legal_name">
            <div class="each">
              <div class="eachT">法定代表人姓名</div>
              <div class="eachD">
                {{ oldDetail.legal_name ? oldDetail.legal_name : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">法定代表人姓名</div>
              <div class="eachD">
                {{ newDetail.legal_name ? newDetail.legal_name : "--" }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.legal_tel">
            <div class="each">
              <div class="eachT">法定代表人联系电话</div>
              <div class="eachD">
                {{ oldDetail.legal_tel ? oldDetail.legal_tel : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">法定代表人联系电话</div>
              <div class="eachD">
                {{ newDetail.legal_tel ? newDetail.legal_tel : "--" }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.legal_title">
            <div class="each">
              <div class="eachT">法定代表人职称</div>
              <div class="eachD">
                {{ oldDetail.legal_title ? oldDetail.legal_title : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">法定代表人职称</div>
              <div class="eachD">
                {{ newDetail.legal_title ? newDetail.legal_title : "--" }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.technical_name">
            <div class="each">
              <div class="eachT">技术负责人姓名</div>
              <div class="eachD">
                {{ oldDetail.technical_name ? oldDetail.technical_name : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">技术负责人姓名</div>
              <div class="eachD">
                {{ newDetail.technical_name ? newDetail.technical_name : "--" }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.technical_tel">
            <div class="each">
              <div class="eachT">技术负责人联系电话</div>
              <div class="eachD">
                {{ oldDetail.technical_tel ? oldDetail.technical_tel : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">技术负责人联系电话</div>
              <div class="eachD">
                {{ newDetail.technical_tel ? newDetail.technical_tel : "--" }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.technical_title">
            <div class="each">
              <div class="eachT">技术负责人职称</div>
              <div class="eachD">
                {{
                  oldDetail.technical_title ? oldDetail.technical_title : "--"
                }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">技术负责人职称</div>
              <div class="eachD">
                {{
                  newDetail.technical_title ? oldDetail.technical_title : "--"
                }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.technical_code">
            <div class="each">
              <div class="eachT">技术负责人一级注册造价工程师证书编号</div>
              <div class="eachD">
                {{ oldDetail.technical_code ? oldDetail.technical_code : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">技术负责人一级注册造价工程师证书编号</div>
              <div class="eachD">
                {{ newDetail.technical_code ? newDetail.technical_code : "--" }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.contact_name">
            <div class="each">
              <div class="eachT">企业联系人姓名</div>
              <div class="eachD">
                {{ oldDetail.contact_name ? oldDetail.contact_name : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">企业联系人姓名</div>
              <div class="eachD">
                {{ newDetail.contact_name ? newDetail.contact_name : "--" }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.contact_tel">
            <div class="each">
              <div class="eachT">企业联系人电话（传真）</div>
              <div class="eachD">
                {{ oldDetail.contact_tel ? oldDetail.contact_tel : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">企业联系人电话（传真）</div>
              <div class="eachD">
                {{ newDetail.contact_tel ? newDetail.contact_tel : "--" }}
              </div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.contact_email">
            <div class="each">
              <div class="eachT">电子邮箱</div>
              <div class="eachD">
                {{ oldDetail.contact_email ? oldDetail.contact_email : "--" }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">电子邮箱</div>
              <div class="eachD">
                {{ newDetail.contact_email ? newDetail.contact_email : "--" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      资质信息-->
      <div
        class="contBox"
        v-if="
          upNew.license_image ||
          upNew.promise_image ||
          upNew.legal_idcard_f_image ||
          upNew.legal_idcard_b_image ||
          upNew.technical_idcard_f_image ||
          upNew.technical_idcard_b_image ||
          upNew.contact_idcard_f_image ||
          upNew.contact_idcard_b_image ||
          upNew.legal_title_image ||
          upOld.legal_title_image ||
          upNew.technical_title_image
        "
      >
        <div
          class="contT"
          v-if="
            (upNew.name ||
              upNew.province ||
              upNew.city ||
              upNew.county ||
              upNew.address ||
              upNew.com_create_time ||
              upNew.eco_type ||
              upNew.capital ||
              upNew.y_province ||
              upNew.y_city ||
              upNew.y_county ||
              upNew.y_address ||
              upNew.y_phone) &&
            (upNew.legal_name ||
              upNew.legal_tel ||
              upNew.legal_title ||
              upNew.technical_name ||
              upNew.technical_tel ||
              upNew.technical_title ||
              upNew.technical_code ||
              upNew.contact_name ||
              upNew.contact_tel ||
              upNew.contact_email)
          "
        >
          3. 资质信息
        </div>
        <div
          class="contT"
          v-else-if="
            upNew.name ||
            upNew.province ||
            upNew.city ||
            upNew.county ||
            upNew.address ||
            upNew.com_create_time ||
            upNew.eco_type ||
            upNew.capital ||
            upNew.y_province ||
            upNew.y_city ||
            upNew.y_county ||
            upNew.y_address ||
            upNew.y_phone ||
            upNew.legal_name ||
            upNew.legal_tel ||
            upNew.legal_title ||
            upNew.technical_name ||
            upNew.technical_tel ||
            upNew.technical_title ||
            upNew.technical_code ||
            upNew.contact_name ||
            upNew.contact_tel ||
            upNew.contact_email
          "
        >
          2. 资质信息
        </div>
        <div class="contT" v-else>1. 资质信息</div>
        <div class="contRightCont">
          <div class="cont" v-if="upNew && upNew.license_image">
            <div class="each">
              <div class="eachT">营业执照</div>
              <a :href="oldDetail.license_image" target="_blank" class="eachC"
              >查看文件</a
              >
            </div>
            <div class="each">
              <div class="eachT">营业执照</div>
              <a :href="newDetail.license_image" target="_blank" class="eachC"
              >查看文件</a
              >
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.promise_image">
            <div class="each">
              <div class="eachT">上传企业承诺书</div>
              <a :href="oldDetail.promise_image" target="_blank" class="eachC"
              >查看文件</a
              >
            </div>
            <div class="each">
              <div class="eachT">上传企业承诺书</div>
              <a :href="newDetail.promise_image" target="_blank" class="eachC"
              >查看文件</a
              >
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.legal_idcard_f_image">
            <div class="each">
              <div class="eachT">法定代表人身份证(正面)</div>
              <a
                :href="oldDetail.legal_idcard_f_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
            <div class="each">
              <div class="eachT">法定代表人身份证(正面)</div>
              <a
                :href="newDetail.legal_idcard_f_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.legal_idcard_b_image">
            <div class="each">
              <div class="eachT">法定代表人身份证(反面)</div>
              <a
                :href="oldDetail.legal_idcard_b_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
            <div class="each">
              <div class="eachT">法定代表人身份证(反面)</div>
              <a
                :href="newDetail.legal_idcard_b_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.technical_idcard_f_image">
            <div class="each">
              <div class="eachT">技术负责人身份证(正面)</div>
              <a
                :href="oldDetail.technical_idcard_f_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
            <div class="each">
              <div class="eachT">技术负责人身份证(正面)</div>
              <a
                :href="newDetail.technical_idcard_f_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.technical_idcard_b_image">
            <div class="each">
              <div class="eachT">技术负责人身份证(反面)</div>
              <a
                :href="oldDetail.technical_idcard_b_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
            <div class="each">
              <div class="eachT">技术负责人身份证(反面)</div>
              <a
                :href="newDetail.technical_idcard_b_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.contact_idcard_f_image">
            <div class="each">
              <div class="eachT">企业联系人身份证(正面)</div>
              <a
                :href="oldDetail.contact_idcard_f_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
            <div class="each">
              <div class="eachT">企业联系人身份证(正面)</div>
              <a
                :href="newDetail.contact_idcard_f_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.contact_idcard_b_image">
            <div class="each">
              <div class="eachT">企业联系人身份证(反面)</div>
              <a
                :href="oldDetail.contact_idcard_b_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
            <div class="each">
              <div class="eachT">企业联系人身份证(反面)</div>
              <a
                :href="newDetail.contact_idcard_b_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
          </div>
          <div
            class="cont"
            v-if="
              (upNew && upNew.legal_title_image) ||
              (upOld && upOld.legal_title_image)
            "
          >
            <div class="each">
              <div class="eachT">法定代表人职称证</div>
              <a
                v-if="upOld && upOld.legal_title_image"
                :href="oldDetail.legal_title_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
              <div v-else class="c maT">无</div>
            </div>
            <div class="each">
              <div class="eachT">法定代表人职称证</div>
              <a
                v-if="upNew && upNew.legal_title_image"
                :href="newDetail.legal_title_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
              <div v-else class="c maT">无</div>
            </div>
          </div>
          <div class="cont" v-if="upNew && upNew.technical_title_image">
            <div class="each">
              <div class="eachT">技术负责人职称证</div>
              <a
                :href="oldDetail.technical_title_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
            <div class="each">
              <div class="eachT">技术负责人职称证</div>
              <a
                :href="newDetail.technical_title_image"
                target="_blank"
                class="eachC"
              >查看文件</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateDetail } from "@/api/update.js";

export default {
  name: "updateResult",
  created() {
    this.id = this.$route.query.id;
    this.init();
  },
  data() {
    return {
      p: {
        num1: 2,
        num2: 3
      },
      status: null, //审核状态
      remarks: null, //审核意见
      time: null, //审核时间

      id: "",
      newDetail: {}, //新详情
      oldDetail: {}, //老详情
      comType: null, //企业类型

      upOld: {}, //老内容
      upNew: {}, //新内容

      isShow: false //默认不展示，值不同才展示
    };
  },
  methods: {
    async init() {
      const res = await updateDetail({ id: this.id });
      this.newDetail = res.all_new;
      this.oldDetail = res.all_old;

      this.status = res.info.status;
      this.remarks = res.info.remarks;
      this.time = res.info.create_time;
      this.comType = res.member_type; //企业类型

      // console.log(this.newDetail, "this.newDetail");
      //
      // console.log(this.oldDetail, "this.oldDetail");

      let tepOld = res.all_old;
      let tepNew = res.all_new;

      for (let item1 in tepOld) {
        for (let item2 in tepNew) {
          if (item1 == item2) {
            //键相等才去做比较
            if (tepOld[item1] != tepNew[item2]) {
              // console.log([tepOld[item1]], item1);
              // console.log([tepNew[item2]], item2);

              this.upOld[item1] = tepOld[item1];
              this.upNew[item2] = tepNew[item2];
            }
            // else {
            //   this.isShow = false;
            // }
          }
        }
      }
      // console.log(this.upOld, "this.upOld");
      // console.log(this.upNew, "this.upNew");

      // let tepNew = res.all_new;
    }
  }
};
</script>

<style lang="less" scoped>
.plan {
  height: 60px;
  background: #ffffff;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;

  .t {
    font-size: 20px;
    color: #333333;
    display: flex;
    align-items: center;

    .statusShow {
      font-size: 12px;
      color: #ffffff;
      margin-left: 8px;
      padding: 2px;
      border-radius: 2px;
    }

    .error {
      background: rgb(243, 35, 35);
    }

    .waiting {
      background: rgb(68, 150, 241);
    }

    .end {
      background: rgb(37, 162, 45);
    }
  }

  .return {
    display: flex;
    cursor: pointer;
    align-items: center;
    font-size: 14px;
    color: #4379f6;

    img {
      width: 12px;
      height: 10px;
      margin-left: 3px;
    }
  }
}

.statusBox {
  margin-top: 15px;
  background: #ffffff;
  border-radius: 2px;
  padding: 18px 58px;
  display: flex;
  align-items: center;

  img {
    width: 44px;
    height: 44px;
  }

  .statusCont {
    margin-left: 40px;

    .item {
      display: flex;
      align-items: center;
      margin-top: 10px;

      &:first-child {
        margin-top: unset;
      }

      .t {
        font-size: 12px;
        color: #999999;
      }
    }
  }
}

.c {
  font-size: 12px;
  color: #333333;
}

.maT {
  margin-top: 4px;
}

.headBox {
  width: 100%;
  height: 50px;
  background: #eaeaea;
  border-radius: 2px 2px 0px 0px;
  margin-top: 20px;
  display: flex;
  align-items: center;

  .title {
    flex: 1;
    font-size: 12px;
    font-weight: 700;
    color: #333333;
    text-align: center;
  }
}

.bg {
  background: #ffffff;
  border-radius: 0 0 2px 2px;
  padding: 30px 20px 50px;

  .contBox {
    display: flex;
    align-items: flex-start;

    .contT {
      font-size: 12px;
      font-weight: 700;
      color: #333333;
      min-width: 150px;
    }

    .contRightCont {
      flex: 1;

      .cont {
        display: flex;
        margin-top: 16px;

        &:first-child {
          margin-top: unset;
        }

        .each {
          width: 50%;

          .eachT {
            font-size: 12px;
            color: #999999;
          }

          .eachD {
            font-size: 12px;
            color: #333333;
            margin-top: 4px;
          }

          .eachC {
            font-size: 12px;
            color: #4379f6;
            margin-top: 4px;
          }
        }
      }
    }
  }
}

.red {
  color: red !important;
  font-size: 12px;
  margin-top: 4px;
}
</style>
